import request from "./axiosConfig";

/**
 * 获取职业发展信息
 */
export function getCareerInfo() {
  return request({
    url: "/interface/examination/career",
    method: "get",
  });
}
